var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-field",
      class: { "disable-html-component": _vm.missing },
    },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { value: "error", hidden: !_vm.missing },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: {
            placeholder: "Select",
            size: "small",
            "allow-create": _vm.allowCreate,
            filterable: _vm.allowCreate,
            disabled: _vm.disabled,
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }